import React, {Component} from "react";
import {connect} from "react-redux";

class Basic extends Component {
  render() {
    const companyData = this.props.Company;
    return (
      <div className="row g-3 mb-3">
        <div className="col-xl-4 col-lg-4">
          <div className="card">
            <div className="card-header">
              <h5>Basic Information</h5>
            </div>
            <div className="card-body">
              <div className="card text-center">
                <div className="pt-10">
                  <div className="flexbox">
                    <h6>Name</h6>
                    <p>{companyData.Name}</p>
                  </div>
                  <div className="flexbox">
                    <h6>TagLine</h6>
                    <p>{companyData.TagLine}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Address</h6>
                    <p>{companyData.Address}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Contact</h6>
                    <p>{companyData.Contact}</p>
                  </div>
                  <div className="flexbox">
                    <h6>VAT/PAN</h6>
                    <p>{companyData.VatPan}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Email</h6>
                    <p>{companyData.Email}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Short Code</h6>
                    <span className={`badge badge-pill badge-purple `}>
                      {companyData.ShortName}
                    </span>
                  </div>
                  <div className="flexbox">
                    <h6>Website</h6>
                    <p>{companyData.Website} </p>
                  </div>
                  <div className="flexbox">
                    <h6>Time Zone</h6>
                    <p> {companyData.TimeZone}</p>
                  </div>
                </div>
                <div className="bb-1 h-10px"></div>
                <div className="pt-20">
                  <div className="flexbox">
                    <h6>Cost Price</h6>
                    <p>{companyData.costprice}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4">
          <div className="card">
            <div className="card-header">
              <h5>Default Accounts</h5>
            </div>
            <div className="card-body">
              <div className="card text-center">
                <div className="pt-10">
                  <div className="flexbox">
                    <h6>Cash In Hand</h6>
                    <p>{companyData.Name}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Bank Account</h6>
                    <p>{companyData.TagLine}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Fonepay Account</h6>
                    <p>{companyData.Address}</p>
                  </div>
                  <div className="flexbox">
                    <h6>sss</h6>
                    <p>{companyData.Contact}</p>
                  </div>
                  <div className="flexbox">
                    <h6>VAT/PAN</h6>
                    <p>{companyData.VatPan}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Email</h6>
                    <p>{companyData.Email}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Short Code</h6>
                    <span className={`badge badge-pill badge-purple `}>
                      {companyData.ShortName}
                    </span>
                  </div>
                  <div className="flexbox">
                    <h6>Website</h6>
                    <p>{companyData.Website} </p>
                  </div>
                  <div className="flexbox">
                    <h6>Time Zone</h6>
                    <p> {companyData.TimeZone}</p>
                  </div>
                </div>
                <div className="bb-1 h-10px"></div>
                <div className="pt-20">
                  <div className="flexbox">
                    <h6>Cost Price</h6>
                    <p>{companyData.costprice}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4">
          <div className="card">
            <div className="card-header">
              <h5>SMS/Notification</h5>
            </div>
            <div className="card-body">
              <div className="card text-center">
                <div className="pt-10">
                  <div className="flexbox">
                    <h6>Cash In Hand</h6>
                    <p>{companyData.Name}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Bank Account</h6>
                    <p>{companyData.TagLine}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Fonepay Account</h6>
                    <p>{companyData.Address}</p>
                  </div>
                  <div className="flexbox">
                    <h6>sss</h6>
                    <p>{companyData.Contact}</p>
                  </div>
                  <div className="flexbox">
                    <h6>VAT/PAN</h6>
                    <p>{companyData.VatPan}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Email</h6>
                    <p>{companyData.Email}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Short Code</h6>
                    <span className={`badge badge-pill badge-purple `}>
                      {companyData.ShortName}
                    </span>
                  </div>
                  <div className="flexbox">
                    <h6>Website</h6>
                    <p>{companyData.Website} </p>
                  </div>
                  <div className="flexbox">
                    <h6>Time Zone</h6>
                    <p> {companyData.TimeZone}</p>
                  </div>
                </div>
                <div className="bb-1 h-10px"></div>
                <div className="pt-20">
                  <div className="flexbox">
                    <h6>Cost Price</h6>
                    <p>{companyData.costprice}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    Company: state.Auth.company,
  }),
  {}
)(Basic);
